<template>
	<div class="display-info">
		<el-form
			ref="displayFormRef"
			:model="formData"
			:rules="formRules"
			label-width="100px"
			label-position="top"
			class="display-form"
		>
			<!-- 基本展示信息 -->
			<div class="section">
				<div class="section-title">
					基本展示信息
					<span class="section-sub">（填写在建设信息网宣传首页面展示的基础信息）</span>
				</div>

				<!-- 宣传标题 -->
				<el-row :gutter="40">
					<!-- 仅企业宣传展示 -->
					<el-col v-if="displaySectorType === '1'" :span="24">
						<el-form-item label="宣传标题：" prop="title">
							<el-input
								v-model="formData.title"
								placeholder="请输入宣传标题，简洁有力，不超过30字"
								maxlength="30"
								:show-word-limit="true"
								clearable
							/>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="所属板块：" prop="">
							{{ displaySectorName }}
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<!-- 申请企业 -->
						<el-form-item label="申请企业：" prop="companyName">
							<el-input
								v-model="formData.companyName"
								placeholder="请输入申请企业名称"
								clearable
								maxlength="30"
								:show-word-limit="true"
							/>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row :gutter="40">
					<el-col :span="12">
						<el-form-item label="统一社会信用代码：" prop="companyCode">
							<el-input v-model="formData.companyCode" placeholder="请输入统一社会信用代码" clearable />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<!-- 联系电话 -->
						<el-form-item label="联系电话：" prop="telephone">
							<el-input v-model="formData.telephone" placeholder="请输入联系电话" clearable maxlength="11" />
						</el-form-item>
					</el-col>
				</el-row>

				<el-row :gutter="40">
					<el-col :span="24">
						<!-- 宣传详情 -->
						<el-form-item label="宣传简介：" prop="displayDetails">
							<template slot="label">
								宣传简介
								<el-popover placement="right" :width="400" trigger="hover">
									<template slot="reference">
										<i class="el-icon-question"></i>
									</template>
									<div class="popover-content">
										<h4 class="popover-title">展示位置说明</h4>
										<p class="popover-desc">
											此简介将展示在{{
												displaySectorType === '2' ? '企业风采' : '首页企业宣传'
											}}列表的卡片摘要区域，帮助用户第一眼了解企业特色
										</p>
										<div class="popover-image">
											<img
												:src="
													displaySectorType === '2' ? require('@/assets/mall/jianjie1.png') : require('@/assets/mall/jianjie.png')
												"
												alt="展示位置"
											/>
										</div>
									</div>
								</el-popover>
							</template>
							<el-input
								v-model="formData.displayDetails"
								type="textarea"
								:rows="3"
								placeholder="请输入展示的宣传简介，让用户第一眼了解您企业宣传的内容和特色..."
								maxlength="100"
								show-word-limit
								resize="none"
							/>
						</el-form-item>
					</el-col>
				</el-row>

				<!-- 标签（仅企业风采） -->
				<el-row v-if="displaySectorType === '2'" :gutter="40">
					<el-col :span="24">
						<el-form-item label="标签：" prop="tags">
							<div class="tag-input-wrapper">
								<el-tag
									v-for="(tag, index) in formData.tags"
									:key="index"
									closable
									:disable-transitions="false"
									class="tag-item"
									@close="handleRemoveTag(index)"
								>
									{{ tag }}
								</el-tag>
								<el-input
									v-if="formData.tags.length < 10"
									ref="tagInputRef"
									v-model="tagInputValue"
									class="tag-input"
									size="small"
									maxlength="5"
									placeholder="输入标签，回车添加"
									@keyup.enter.native="handleAddTag"
									@blur="handleAddTag"
								/>
								<span v-if="formData.tags.length >= 5" class="tag-limit-tip">最多添加5个标签</span>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
			</div>

			<!-- 展示图片 -->
			<div class="section">
				<div class="section-title">
					展示图片
					<span class="section-sub">（展示在平台页面的宣传图，建议尺寸750*350px）</span>
				</div>

				<el-row :gutter="40">
					<!-- 左栏 -->
					<el-col :span="24">
						<!-- 展示图 -->
						<el-form-item label="" prop="displayImages">
							<UploadDragImages
								ref="uploadImagesRef"
								v-model="formData.displayImages"
								:action="uploadAction"
								:data="uploadData"
								:headers="uploadHeaders"
								:limit="1"
								:size="5"
								accept=".jpg,.jpeg,.png"
								:preview-url="previewUrl"
								:delete-api="deleteApi"
							/>
						</el-form-item>
					</el-col>
				</el-row>
			</div>

			<!-- 展示位置及时长选择 -->
			<div class="section">
				<div class="section-title">
					展示位置及时长选择
					<span class="section-sub">（不同位置曝光量与价格不同）</span>
				</div>

				<!-- 两张大卡片布局，参考member-benefits -->
				<div class="location-cards">
					<!-- 首页头条卡片 -->
					<div class="location-card">
						<h4 class="location-title">
							<span>首页头条</span>
							头版头条顶部图轮播，曝光量大
						</h4>
						<div class="duration-list">
							<div
								v-for="item in headlinePackages"
								:key="item.id"
								class="duration-item"
								:class="{ active: selectedPackage.durationId === item.id && selectedPackage.locationId === 'home-headline' }"
								@click="handleSelectPackage(item, 'home-headline', '首页头条')"
							>
								<!-- 活动标签 -->
								<div v-if="item.tag" class="tag-label">{{ item.tag }}</div>
								<h5 class="duration-text">{{ formatDuration(item.longDuration) }}</h5>
								<div class="price-box">
									<p class="now-price">
										<span>¥</span>
										{{ item.eventPrice }}
									</p>
									<p v-if="item.packagePrice !== item.eventPrice" class="old-price">
										<span>¥</span>
										{{ item.packagePrice }}
									</p>
								</div>
							</div>
						</div>
					</div>

					<!-- 宣传专栏卡片 -->
					<div class="location-card">
						<h4 class="location-title">
							<span>专栏显示</span>
							专栏显示
						</h4>
						<div class="duration-list">
							<div
								v-for="item in columnPackages"
								:key="item.id"
								class="duration-item"
								:class="{ active: selectedPackage.durationId === item.id && selectedPackage.locationId === 'promotion-column' }"
								@click="handleSelectPackage(item, 'promotion-column', '专栏显示')"
							>
								<!-- 活动标签 -->
								<div v-if="item.tag" class="tag-label">{{ item.tag }}</div>
								<h5 class="duration-text">{{ formatDuration(item.longDuration) }}</h5>
								<div class="price-box">
									<p class="now-price">
										<span>¥</span>
										{{ item.eventPrice }}
									</p>
									<p v-if="item.packagePrice !== item.eventPrice" class="old-price">
										<span>¥</span>
										{{ item.packagePrice }}
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- 费用汇总 -->
			<div class="section">
				<div class="section-title">
					费用汇总
					<span class="section-sub">（当前选择的展示方案）</span>
				</div>
				<div class="summary-box">
					<div class="summary-row">
						<span class="summary-label">展示位置：</span>
						<span class="summary-value">{{ selectedPackage.locationName || '-' }}</span>
					</div>
					<div class="summary-row">
						<span class="summary-label">购买时长：</span>
						<span class="summary-value">{{ selectedPackage.durationName || '-' }}</span>
					</div>
					<div class="summary-row">
						<span class="summary-label">本次费用：</span>
						<span class="summary-price">
							<span class="price-symbol">¥</span>
							<span class="price-value">{{ selectedPackage.eventPrice || 0 }}</span>
						</span>
					</div>
				</div>
			</div>
		</el-form>
	</div>
</template>

<script>
	import UploadDragImages from '@/components/UploadDragImages/index.vue'
	import {
		deleteMerchantFile,
		previewMerchantFile,
		queryMerchantFileList,
		queryMerchantOrderDetail,
		queryMerchantOrderPrice,
		uploadMerchantFile
	} from '@/api/mall'
	import { getToken } from '@/utils/auth'
	import { ENUM_DISPLAY_SECTOR, FILE_BUSINESS_TYPE } from '@/enum/index.js'
	import { validateUniscid } from '@/utils/jr-validate'
	import { mapGetters } from 'vuex'

	/**
	 * @description 购买流程-展示信息表单组件
	 */
	export default {
		name: 'DisplayInfo',
		components: {
			UploadDragImages
		},
		props: {
			// 初始表单数据
			initData: {
				type: Object,
				default: () => ({})
			},
			// 页面级业务ID
			businessId: {
				type: String,
				default: ''
			},
			// 展示板块类型
			displaySectorType: {
				type: String,
				default: ''
			},
			// 是否重新提交
			resubmit: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				// 表单数据
				formData: {
					// 宣传标题
					title: '',
					// 展示板块：1企业宣传，2企业风采
					displaySector: '1',
					// 企业名称
					companyName: '',
					companyCode: '',
					// 联系电话
					telephone: '',
					// 宣传简介
					displayDetails: '',
					// 售价
					sellingPrice: '',
					// 售价id
					sellingPriceId: '',
					// 活动id
					eventId: '',
					// 购买时长，单位按业务配置，一般为天
					purchaseTime: '',
					// 购买套餐id
					purchaseTimeId: '',
					// 购买的展示类型编码：100 企业宣传；200 企业风采；300 宣传头条；400 风采头条
					displayType: '',
					// 企业风采标签
					tags: [],
					// 展示图附件
					displayImages: []
				},
				// 接口返回的位置列表（首页头条、宣传专栏）
				locationList: [],
				// 当前选中的套餐信息（与member-benefits的activityPackageInfo对应）
				selectedPackage: {
					// 位置id
					locationId: '',
					// 位置名称
					locationName: '',
					// 时长id
					durationId: '',
					// 时长名称
					durationName: '',
					// 活动id
					eventId: '',
					// 套餐id
					packageId: '',
					// 活动名称
					eventName: '',
					// 活动到期时间
					eventEndTime: '',
					// 原价
					packagePrice: '',
					// 活动价
					eventPrice: '',
					// 活动标签
					tag: ''
				},
				// 接口返回的套餐数据（按packageType分组）
				pricePackages: {},
				// 表单校验规则
				formRules: {
					title: [{ required: true, message: '请输入宣传标题', trigger: 'blur' }],
					displaySector: [{ required: true, message: '请输入展示板块', trigger: 'blur' }],
					section: [{ required: true, message: '请输入板块', trigger: 'blur' }],
					displayImages: [
						{
							required: true,
							message: '请上传展示图',
							trigger: 'change',
							validator: (rule, value, callback) => {
								if (!value || value.length === 0) {
									callback(new Error('请上传展示图'))
								} else {
									callback()
								}
							}
						}
					],
					companyName: [{ required: true, message: '请输入申请企业', trigger: 'blur' }],
					companyCode: [
						{ required: true, message: '请输入统一社会信用代码', trigger: 'blur' },
						{ validator: validateUniscid, trigger: 'blur' }
					],
					telephone: [
						{ required: true, message: '请输入联系电话', trigger: 'blur' },
						{ pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
					],
					displayDetails: [{ required: true, message: '请输入宣传详情', trigger: 'blur' }],
					displayLocationId: [{ required: true, message: '请选择位置', trigger: 'change' }],
					tags: [
						{ required: true, message: '请添加至少一个标签', trigger: 'change' },
						{
							validator: (rule, value, callback) => {
								if (this.displaySectorType === '2' && (!value || value.length === 0)) {
									callback(new Error('请添加至少一个标签'))
								} else {
									callback()
								}
							},
							trigger: 'change'
						}
					]
				},
				// 上传配置
				uploadAction: uploadMerchantFile(),
				previewUrl: previewMerchantFile(),
				deleteApi: deleteMerchantFile,
				uploadHeaders: {
					InternetToken: getToken()
				},
				// 展示位置字典
				displayLocationOptions: [],
				// 标签输入临时值
				tagInputValue: ''
			}
		},
		computed: {
			...mapGetters(['userId']),
			// 上传额外参数
			uploadData() {
				return {
					businessId: this.businessId,
					fileBusinessType: FILE_BUSINESS_TYPE.DISPLAY_IMAGE
				}
			},
			// 展示板块名称
			displaySectorName() {
				return ENUM_DISPLAY_SECTOR[this.displaySectorType] || ''
			},
			// 首页头条套餐（企业宣传:300, 企业风采:400）
			headlinePackages() {
				const type = this.displaySectorType === '2' ? '400' : '300'
				return this.pricePackages[type] || []
			},
			// 宣传专栏套餐（企业宣传:100, 企业风采:200）
			columnPackages() {
				const type = this.displaySectorType === '2' ? '200' : '100'
				return this.pricePackages[type] || []
			}
		},
		watch: {
			initData: {
				handler(newVal) {
					if (newVal && Object.keys(newVal).length > 0) {
						this.formData = { ...this.formData, ...newVal }
					}
				},
				immediate: true,
				deep: true
			}
		},
		async created() {
			await this.handleQueryPrice()

			if (this.resubmit) {
				this.getOrderDetail()
				this.getDisplayImages()
			} else {
				// 初始化默认选中
				this.initDefaultSelection()
			}
		},
		mounted() {},
		methods: {
			// 查询订单详情
			async getOrderDetail() {
				if (!this.businessId) {
					return
				}

				// 调用API查询订单详情
				const response = await queryMerchantOrderDetail({
					id: this.businessId
				})

				const { data } = response
				const { merchantDisplayInfo } = data

				// 同步到formData
				this.formData.title = merchantDisplayInfo.title || ''
				this.formData.displaySector = merchantDisplayInfo.displaySector.toString() || ''
				this.formData.companyName = merchantDisplayInfo.companyName || ''
				this.formData.companyCode = merchantDisplayInfo.companyCode || ''
				this.formData.telephone = merchantDisplayInfo.telephone || ''
				this.formData.displayDetails = merchantDisplayInfo.displayDetails || ''
				this.formData.sellingPrice = merchantDisplayInfo.sellingPrice || ''
				this.formData.sellingPriceId = merchantDisplayInfo.sellingPriceId || ''
				this.formData.eventId = data.eventId || ''
				this.formData.purchaseTime = merchantDisplayInfo.purchaseTime || ''
				this.formData.purchaseTimeId = merchantDisplayInfo.purchaseTimeId || ''
				this.formData.displayType = merchantDisplayInfo.displayType || ''
				this.formData.tags = merchantDisplayInfo.tag.split(',') || []

				// 回显用户之前所选购买信息
				if (['100', '200'].includes(this.formData.displayType)) {
					this.selectedPackage.locationId = 'promotion-column'
					this.selectedPackage.locationName = '专栏显示'
				} else if (['300', '400'].includes(this.formData.displayType)) {
					this.selectedPackage.locationId = 'home-headline'
					this.selectedPackage.locationName = '首页头条'
				}
				this.selectedPackage.durationId = merchantDisplayInfo.sellingPriceId || ''
				this.selectedPackage.durationName = this.formatDuration(merchantDisplayInfo.purchaseTime || 0)
				this.selectedPackage.eventPrice = merchantDisplayInfo.sellingPrice || ''
			},

			// 获取展示图
			getDisplayImages() {
				queryMerchantFileList({
					businessId: this.businessId,
					fileBusinessType: FILE_BUSINESS_TYPE.DISPLAY_IMAGE
				}).then(response => {
					const { data } = response || {}
					const list = Array.isArray(data) ? data : []
					this.formData.displayImages = list.map(item => ({
						fileId: item.id,
						url: previewMerchantFile() + item.id
					}))
				})
			},

			// 查询价格及活动
			async handleQueryPrice() {
				const packageTypeList = this.displaySectorType === '2' ? '200,400' : '100,300'
				const response = await queryMerchantOrderPrice({ packageTypeList, userId: this.userId })
				if (response.data && response.data.length > 0) {
					// 按 packageType 分组，并按 longDuration 降序排序（长的在前，价格高的在前）
					this.pricePackages = {}
					response.data.forEach(item => {
						if (!this.pricePackages[item.packageType]) {
							this.pricePackages[item.packageType] = []
						}
						this.pricePackages[item.packageType].push(item)
					})
					// 对每个分组按 longDuration 降序排序
					Object.keys(this.pricePackages).forEach(key => {
						this.pricePackages[key].sort((a, b) => b.longDuration - a.longDuration)
					})
				}
			},

			// 选择套餐（同时确定位置）
			handleSelectPackage(item, locationId, locationName) {
				if (this.resubmit) {
					// 重新提交时，不进行套餐选择
					return
				}
				this.selectedPackage.locationId = locationId
				this.selectedPackage.locationName = locationName
				this.selectedPackage.durationId = item.id
				this.selectedPackage.durationName = this.formatDuration(item.longDuration)
				this.selectedPackage.eventPrice = item.eventPrice
				// 同步到formData
				this.formData.purchaseTimeId = item.itemPackageId
				this.formData.purchaseTime = item.longDuration
				this.formData.sellingPrice = item.eventPrice
				this.formData.sellingPriceId = item.id
				// 活动id
				this.formData.eventId = item.itemEventPromotionId
				// 设置展示板块：1企业宣传，2企业风采
				this.formData.displaySector = this.displaySectorType === '2' ? '2' : '1'
				// 设置购买的展示类型编码：100 企业宣传-宣传专栏；200 企业风采-宣传专栏；300 企业宣传-首页头条；400 企业风采-首页头条
				const isEnterpriseStyle = this.displaySectorType === '2'
				const isHeadline = locationId === 'home-headline'
				if (isEnterpriseStyle && isHeadline) {
					this.formData.displayType = '400'
				} else if (isEnterpriseStyle && !isHeadline) {
					this.formData.displayType = '200'
				} else if (!isEnterpriseStyle && isHeadline) {
					this.formData.displayType = '300'
				} else {
					this.formData.displayType = '100'
				}
			},
			// 格式化时长显示
			formatDuration(days) {
				if (!days) return ''
				const daysNum = parseInt(days)
				if (daysNum >= 365) {
					const years = Math.floor(daysNum / 365)
					return `${years}年`
				} else {
					const months = Math.ceil(daysNum / 30)
					return `${months}个月`
				}
			},
			// 初始化默认选中
			initDefaultSelection() {
				const firstItem = this.headlinePackages[0]
				if (firstItem) {
					this.handleSelectPackage(firstItem, 'home-headline', '首页头条')
				}
			},
			// 添加标签
			handleAddTag() {
				let value = this.tagInputValue.trim()
				if (!value) {
					this.tagInputValue = ''
					return
				}
				// 过滤分隔符，避免与存储格式冲突
				value = value.replace(/[,，]/g, '')
				if (!value) {
					this.tagInputValue = ''
					return
				}
				if (this.formData.tags.length >= 5) return
				if (this.formData.tags.includes(value)) {
					this.$message.warning('标签已存在')
					this.tagInputValue = ''
					return
				}
				this.formData.tags.push(value)
				this.tagInputValue = ''
			},
			// 删除标签
			handleRemoveTag(index) {
				this.formData.tags.splice(index, 1)
			},
			// 获取表单数据
			getFormData() {
				const data = { ...this.formData }
				data.tag = data.tags.join(',')
				delete data.tags
				return data
			},
			// 校验表单并返回数据
			validate() {
				return new Promise((resolve, reject) => {
					this.$refs.displayFormRef.validate(valid => {
						if (valid) {
							resolve(this.getFormData())
						} else {
							reject(new Error('展示信息表单校验失败'))
						}
					})
				})
			},
			// 重置表单
			resetForm() {
				this.$refs.displayFormRef.resetFields()
			}
		}
	}
</script>

<style lang="scss" scoped>
	.display-info {
		.display-form {
			::v-deep {
				.el-form-item {
					margin-bottom: 15px;
				}

				.el-form-item__label {
					color: #333333;
					font-size: 14px;
					padding: 0;
				}
			}
		}

		// 只读输入框
		.readonly-input {
			::v-deep .el-input__inner {
				background-color: #f5f7fa;
				color: #999;
			}
		}

		// 展示图上传组件样式调整
		.display-upload {
			::v-deep {
				.upload-images-box .el-upload {
					width: 110px;
					height: 110px;

					.images-uploader-icon {
						width: 110px;
						height: 110px;
						line-height: 110px;
						font-size: 32px;
					}
				}

				.upload-images {
					width: 110px;
					height: 110px;
				}
			}
		}

		// 两张大卡片布局（参考member-benefits的pay-box）
		.location-cards {
			display: flex;
			gap: 20px;

			.location-card {
				flex: 1;
				background: #fff;
				background-image: linear-gradient(0deg, #fff4e9, #fff 55%);
				border: 1px solid #ebeef5;
				border-radius: 8px;
				// padding: 24px;
				transition: all 0.3s;
				overflow: hidden;

				&:hover {
					box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
				}

				.location-title {
					padding: 20px 25px;
					font-size: 16px;
					font-weight: bold;
					color: #b26a3f;
					border-bottom: 1px solid #ebeef5;
					background: linear-gradient(90deg, rgba(255, 216, 142, 0.4) 0%, rgba(250, 162, 80, 0.4) 100%);

					span {
						font-size: 22px;
						color: #934e25;
						margin-right: 8px;
					}
				}

				.duration-list {
					display: flex;
					gap: 12px;
					padding: 25px;

					.duration-item {
						position: relative;
						flex: 1;
						border: 1px solid #ffc99d;
						border-radius: 10px;
						// padding: 16px;
						cursor: pointer;
						transition: all 0.3s;
						background: #fff;
						text-align: center;
						position: relative;
						// overflow: hidden;
						display: flex;
						flex-direction: column;
						height: 125px;

						&:hover {
							// border-color: #409eff;
							box-shadow: 0 2px 12px 0 rgba(64, 158, 255, 0.1);
						}

						&.active {
							animation: pulse 0.5s ease;
							box-shadow: 0 2px 12px 0 rgba(64, 158, 255, 0.2);

							.duration-text {
								background-image: linear-gradient(90deg, #ffc664, #ff9338);
								color: #ffffff;
							}

							&::before {
								content: '';
								position: absolute;
								right: 0;
								bottom: 0;
								width: 40px;
								height: 40px;
								background: linear-gradient(90deg, #ffc664 0%, #ff9338 100%);
								clip-path: polygon(100% 0, 100% 100%, 0 100%);
								border-radius: 0 0 10px 0;
							}

							&::after {
								content: '';
								position: absolute;
								right: 5px;
								bottom: 5px;
								width: 16px;
								height: 12px;
								background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1024 1024'%3E%3Cpath d='M892.064 261.888a31.936 31.936 0 0 0-45.216 1.472L421.664 717.248l-220.448-185.216a32 32 0 1 0-41.152 48.992l243.648 204.704a31.872 31.872 0 0 0 20.576 7.488 31.808 31.808 0 0 0 23.36-10.112L893.536 307.136a32 32 0 0 0-1.472-45.248z' fill='%23ffffff'/%3E%3C/svg%3E");
								background-repeat: no-repeat;
								background-size: 100%;
								background-position: 50% 50%;
								z-index: 1;
							}
						}

						// 活动标签
						.tag-label {
							position: absolute;
							top: -10px;
							left: -10px;
							background-image: linear-gradient(135deg, #ff7a18 0%, #ff9538 100%);
							color: #fff;
							font-size: 12px;
							padding: 2px 10px;
							z-index: 2;
							font-weight: bold;
							box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
							clip-path: polygon(0 0, 100% 0, 100% 70%, 85% 100%, 0 100%);
							transform: rotate(-5deg);
						}

						.duration-text {
							height: 40px;
							line-height: 40px;
							font-size: 20px;
							font-weight: bold;
							// color: #303133;
							color: #934e25;
							margin-bottom: 8px;
							margin-top: 0;
							border-radius: 10px 10px 0 0;
							background: linear-gradient(90deg, rgba(255, 216, 142, 0.4), rgba(250, 162, 80, 0.4));
						}

						.price-box {
							flex: 1;
							display: flex;
							flex-direction: column;
							justify-content: center;
							.now-price {
								font-size: 28px;
								color: #e6a23c;
								font-weight: bold;
								margin: 0;

								span {
									font-size: 18px;
								}
							}

							.old-price {
								font-size: 13px;
								color: #c0c4cc;
								text-decoration: line-through;
								margin: 4px 0 0;

								span {
									font-size: 12px;
								}
							}
						}
					}
				}
			}
		}

		// 费用汇总
		.summary-box {
			background: #f5f7fa;
			border-radius: 8px;
			padding: 20px 24px;

			.summary-row {
				display: flex;
				align-items: center;
				margin-bottom: 12px;

				&:last-child {
					margin-bottom: 0;
					padding-top: 12px;
					border-top: 1px dashed #dcdfe6;
				}

				.summary-label {
					font-size: 14px;
					color: #606266;
					width: 80px;
					flex-shrink: 0;
				}

				.summary-value {
					font-size: 14px;
					color: #303133;
					font-weight: 500;
				}

				.summary-price {
					color: #e6a23c;
					font-weight: bold;

					.price-symbol {
						font-size: 16px;
					}

					.price-value {
						font-size: 28px;
					}
				}
			}
		}

		// 售价展示
		.price-display {
			display: flex;
			align-items: baseline;
			justify-content: flex-start;
			padding-right: 20px;
			line-height: 1;

			.price-symbol {
				font-size: 16px;
				color: #e6a23c;
				font-weight: bold;
			}

			.price-value {
				font-size: 28px;
				color: #e6a23c;
				font-weight: bold;
				margin: 0 2px;
			}

			.price-unit {
				font-size: 14px;
				color: #999;
			}
		}
		.tag-input-wrapper {
			display: flex;
			flex-wrap: wrap;
			align-items: center;
			line-height: 1;
			gap: 8px;

			.tag-item {
				margin: 0;
			}

			.tag-input {
				width: 160px;
			}

			.tag-limit-tip {
				font-size: 12px;
				color: #c0c4cc;
			}
		}
	}

	@keyframes pulse {
		0% {
			transform: scale(1);
		}
		50% {
			transform: scale(1.03);
		}
		100% {
			transform: scale(1);
		}
	}
</style>

<style lang="scss">
	// 宣传简介 popover 样式
	.popover-content {
		.popover-title {
			font-size: 15px;
			font-weight: 600;
			color: #303133;
			margin: 0 0 10px;
			padding-bottom: 8px;
			border-bottom: 1px solid #ebeef5;
		}

		.popover-desc {
			font-size: 13px;
			color: #606266;
			line-height: 1.6;
			margin: 0 0 12px;
		}

		.popover-image {
			width: 100%;
			max-height: 200px;
			overflow: hidden;
			border-radius: 4px;
			background: #f5f7fa;
			display: flex;
			align-items: center;
			justify-content: center;

			img {
				width: 100%;
				height: auto;
				max-height: 200px;
				object-fit: contain;
				display: block;
			}
		}
	}
</style>
